import useAuth from '~/hooks/useAuth';
import styles from './NavigationSidebar.module.scss';
import NavigationSidebarContent from './NavigationSidebarContent';

interface NavigationSidebarProps {
  isCompanyAccessible: boolean;
}

const NavigationSidebar: React.FC<NavigationSidebarProps> = ({ isCompanyAccessible }) => {
  const { user } = useAuth();

  if (!user) {
    return null;
  }

  return (
    <div className={styles.container}>
      <NavigationSidebarContent isCompanyAccessible={isCompanyAccessible} />
    </div>
  );
};

export default NavigationSidebar;
